const initState = {}
export default function customerReducer (preState=initState,action){
    const {type,data} = action
    switch (type) {
        case 'save':
            return { ...preState, ...(data?.data || {}) };
        default:
            return {}
    }
}